import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';

/**
 * The email address Firebase Auth is currently signed in as, live.
 *
 * WHY A SCREEN WOULD WANT THIS. Firebase Auth holds ONE signed-in user per
 * browser, shared by every tab on this origin. So the admin screen and a
 * client's till cannot be signed in as different accounts at the same time:
 * signing in at a till replaces the administrator's session, and the admin
 * screen — still mounted, still subscribed — starts getting permission_denied
 * from rules that are working exactly as intended.
 *
 * A screen that holds its own idea of who is signed in therefore has to watch
 * for the ground moving under it, and say so, rather than rendering a database
 * error it cannot explain.
 *
 * @returns {?string} the current account's email, or null when signed out.
 *   `undefined` is never returned: Firebase reports the restored session
 *   synchronously enough that a third state would only invite bugs.
 */
export function useFirebaseAccount() {
  const [email, setEmail] = useState(auth?.currentUser?.email || null);

  useEffect(() => {
    if (!auth) return undefined;
    return onAuthStateChanged(auth, (user) => setEmail(user?.email || null));
  }, []);

  return email;
}

export default useFirebaseAccount;
